/** Google Maps JS API — loaded for Places Autocomplete on event location. */
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

export const GOOGLE_MAPS_LIBRARIES = ['places'];

export const isGoogleMapsConfigured = () => Boolean(GOOGLE_MAPS_API_KEY);
